import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Team, Banner, Pricing, GetQuote, ProjectSection, Features, Clients, Products } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <About /> {/* About Section */}
      <Features /> {/* Features Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <ProjectSection /> {/* Projects Section */}
      <Banner /> {/* Banner Section */}
      <Products /> {/* Products section */}
      <Pricing /> {/* Pricing section */}
      <GetQuote /> {/* Get Quote section */}
      <Team /> {/* Team section */}
      <Testimonials /> {/* Testimonials Slider */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/*Clients Slider */}
    </div>
  )

}

export default HomePage;